import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Checkbox } from 'semantic-ui-react';

import ReactTableWrapper from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { caseInsensitiveFilter } from 'Common/GridHelper';

import 'Styles/pages/familymatchutility/familymatchutility.less';

export class FamilyMatchUtilityApplicationTable extends Component {
  state = {
    expanded: {},
  };

  static defaultProps = {
    loading: false,
  };

  handleCheckedItem = (checkedValue, row) => {
    this.props.checkApplicationGrid(checkedValue, row);

    if (checkedValue === true) {
      this.props.onSelect({ SystemId: row.SystemId, HHId: row.Id });
    } else {
      this.props.onSelect({ SystemId: null, HHId: null });
    }
  };

  studentSubColumns = [
    {
      Header: ' ',
      width: 35,
    },
    {
      Header: 'Student First Name',
      accessor: 'FirstName',
      style: { textAlign: 'center' },
    },
    {
      Header: 'Student Last Name',
      accessor: 'LastName',
      style: { textAlign: 'center' },
    },
    {
      Header: 'Student Middle Name',
      accessor: 'MiddleName',
      style: { textAlign: 'center' },
    },
    {
      Header: 'Site',
      accessor: 'SiteId',
      style: { textAlign: 'center' },
    },
    {
      Header: 'Grade',
      accessor: 'Grade',
      style: { textAlign: 'center' },
    },
  ];

  memberSubColumns = [
    {
      Header: ' ',
      width: 35,
    },
    {
      Header: 'Member First Name',
      accessor: 'FirstName',
      style: { textAlign: 'center' },
    },
    {
      Header: 'Member Last Name',
      accessor: 'LastName',
      style: { textAlign: 'center' },
    },
  ];

  renderSubGrid = (row) => {
    return (
      <div>
        <ReactTable
          className={'family-match-utility-sub-grid'}
          data={row.original.Students}
          columns={this.studentSubColumns}
          minRows={1}
          showPagination={false}
          filterable={false}
          sortable={false}
          noDataText={'No students found'}
          resizable={false}
          getTheadTrProps={() => ({
            className: 'family-match-utility-sub-grid-header-students',
          })}
        />
        <ReactTable
          className={'family-match-utility-sub-grid'}
          data={row.original.Members}
          columns={this.memberSubColumns}
          minRows={1}
          showPagination={false}
          filterable={false}
          sortable={false}
          noDataText={'No members found'}
          resizable={false}
          getTheadTrProps={() => ({
            className: 'family-match-utility-sub-grid-header-members',
          })}
        />
      </div>
    );
  };

  columns = [
    {
      Header: 'Select',
      accessor: 'Selected',
      maxWidth: 60,
      sortable: true,
      filterable: false,
      Cell: ({ original }) => {
        if (original) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original.Selected ? true : false}
                onChange={() => {
                  this.handleCheckedItem(!original.Selected, original);
                }}
              />
            </div>
          );
        }
      },
    },
    {
      Header: 'Family #',
      accessor: 'FamilyId',
      sortable: true,
      show: true,
      visibility: true,
      width: 125,
    },
    {
      Header: 'Parent First Name',
      accessor: 'FirstName',
      show: true,
      visibility: true,
      sortable: true,
      width: 150,
    },
    {
      Header: 'Parent Last Name',
      accessor: 'LastName',
      show: true,
      visibility: true,
      sortable: true,
      width: 150,
    },
    {
      Header: 'Address 1',
      accessor: 'Address1',
      show: true,
      visibility: true,
      sortable: true,
    },
    {
      Header: 'Address 2',
      accessor: 'Address2',
      show: true,
      visibility: true,
      sortable: true,
    },
    {
      Header: 'City',
      accessor: 'City',
      show: true,
      visibility: true,
      sortable: true,
    },
    {
      Header: 'State',
      accessor: 'State',
      show: true,
      visibility: true,
      sortable: true,
    },
    {
      Header: 'Zip Code',
      accessor: 'ZipCode',
      show: true,
      visibility: true,
      sortable: true,
    },
  ];

  render() {
    return (
      <ReactTableWrapper
        className={'family-match-utility-app-grid'}
        saveState={{
          tableName: TableNamesEnum.FAMILY_MATCH_UTILITY_APPLICATIONS_TABLE,
          page: true,
        }}
        loading={this.props.loading}
        data={this.props.applicationData}
        columns={this.columns}
        SubComponent={this.renderSubGrid}
        filterable={true}
        resetPageOnDataChange={false}
        resizable={true}
        defaultFilterMethod={caseInsensitiveFilter}
        noDataText="No Applications Found"
        defaultPageSize={10}
        minRows={5}
        expanded={this.state.expanded}
        showMenu={true}
        showHideColumn={true}
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (column.id === undefined) {
                if (this.state.expanded[rowInfo.viewIndex]) {
                  this.setState({ expanded: {} });
                } else {
                  this.setState({
                    expanded: { [rowInfo.viewIndex]: true },
                  });
                }
              }
            },
          };
        }}
        onPageChange={() => this.setState({ expanded: {} })}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/components/FamilyMatchUtilityApplicationTable.js